import { SearchArea } from '../../../models/search-area/search-area';
import { SearchAreas } from '../../../models/search-area/search-areas';
import { SearchAreaGetResponse } from './search-area-get-response';

export function adaptSearchAreas(array: SearchAreaGetResponse[]): SearchAreas {
  return new SearchAreas(
    array.map(
      res =>
        new SearchArea({
          index: res.index,
          key: res.key,
          name: res.name,
          polyline: res.polyline,
        }),
    ),
  );
}
